import mutate from '../mutations/scratchpad';

const config = {
  development: {
    baseUrl: 'https://svc-stage.homeaway.com/sp2'
  },
  test: {
    baseUrl: 'https://svc-test.homeaway.com/sp2'
  },
  stage: {
    baseUrl: 'https://svc-stage.homeaway.com/sp2'
  },
  production: {
    baseUrl: 'https://svc.homeaway.com/sp2'
  }
};

const getScratchpad = ({ publicUuid, havId, siteName, environment, isUserLogged }) => {
  const userId = isUserLogged && `&publicUserId=${publicUuid}` || `&havId=${havId}` || '';
  const url = `${config[environment].baseUrl}/fullV1?_view=homePage&site=${siteName}${userId}`;

  return fetch(url).then(response => response.json().then(data => mutate(data, siteName)));
};

export { getScratchpad };



// WEBPACK FOOTER //
// ./src/universal/api/clients/scratchpad.js